"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationLogger = void 0;
const tslib_1 = require("tslib");
const __1 = require("..");
const notification_service_1 = require("./notification-service");
const _1 = require(".");
let NotificationLogger = class NotificationLogger extends _1.AbstractLogger {
    constructor(notificationService) {
        super();
        this.notificationService = notificationService;
        this.logLevels = ['Information', 'Warning', 'Error', 'Fatal'];
    }
    useLogLevels(loglevels) {
        this.logLevels = loglevels;
    }
    addEntry(entry) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.logLevels.includes(_1.LogLevel[entry.level])) {
                this.notificationService.add(entry);
            }
        });
    }
};
NotificationLogger = tslib_1.__decorate([
    __1.Injectable({ lifetime: 'scoped' }),
    tslib_1.__metadata("design:paramtypes", [notification_service_1.NotificationService])
], NotificationLogger);
exports.NotificationLogger = NotificationLogger;
//# sourceMappingURL=notification-logger.js.map